// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont,'Lato','DM Serif Display',;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: white;  
  scroll-behavior: auto !important;

}
html {
  scroll-behavior: auto !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas,'Lato','DM Serif Display';
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,yEAAyE;EACzE,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;EACvB,gCAAgC;;AAElC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,+EAA+E;AACjF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont,'Lato','DM Serif Display',;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: white;  \n  scroll-behavior: auto !important;\n\n}\nhtml {\n  scroll-behavior: auto !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas,'Lato','DM Serif Display';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
